import { Component } from '@angular/core';

import {
  Platform,
  LoadingController,
  NavController,
  MenuController,
} from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { Storage } from '@ionic/storage';
import { Router } from '@angular/router';
//Importamos el servicio y la entidad para poder consultar el menu
import { AuthenticationToken } from '../app/entities/credentials';
import { ClientStorage } from '../app/entities/clientStorage';
import { GenericService } from '../app/services/generic.service';
import { Menus } from '../app/entities/menus';
import { environment } from '../environments/environment';
import { ResultInfo } from '../app/entities/ResultInfo';
import { TokenService } from './services/token.service';
import { EmployeeLocation } from '../app/entities/EmployeeLocation';
import { CertificateInventoryDTO } from '../app/entities/CertificateInventoryDTO';
import { AlertController } from '@ionic/angular';
import { SessionService } from '../app/services/session.service';
import { AnalyticsService } from 'src/app/services/analytics.service';
declare let window: any;

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  loading: HTMLIonLoadingElement;
  loggedIn: boolean = false;

  //Model que se usara en la vista, almacenara los menus obtenidos de manera dinamica
  menus;
  clientStorage: ClientStorage;
  WSIdentityUrl = '';
  parametrosmenus: AuthenticationToken;
  resultMenus: ResultInfo<Menus>;

  resultLocation: ResultInfo<EmployeeLocation>;
  location: EmployeeLocation;

  resultCertificate: ResultInfo<CertificateInventoryDTO>;
  certificate: CertificateInventoryDTO;

  menusRefreshed: boolean = false;
  locationsRefreshed: boolean = false;
  LocationID: number;
  LocId: number;
  isEjecutive = false;
  numotifications = 0;
  loggedUser: number;
  LocationName: string;
  locationChanged: boolean = false;

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private storage: Storage,
    private router: Router,
    private loadingCtrl: LoadingController,
    private navCtrl: NavController,
    private statusBar: StatusBar,
    public alertController: AlertController,
    //Instancia al servicio de login
    private genericMenuService: GenericService<Menus>,
    private genericLocation: GenericService<EmployeeLocation>,
    private genericCertificate: GenericService<CertificateInventoryDTO>,
    private tokenService: TokenService,
    private menuprincipal: MenuController,
    private sessionservice: SessionService,
    private analyticsService: AnalyticsService,
  ) {
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
      if (this.platform.is('ios')) {
        this.askTrackingPermission();
        //this.readTrackingPermission();
      }
    });
    this.WSIdentityUrl = environment.WSReservacionCertificados;
    //Llamado al metodo que consulta los menus (validar donde se hara se pone aqui para test)

    // this.tokenService.ActualizarToken().then(data=>{
    //   if(data){
    //   this.clientStorage=data;
    //   //this.GetMenusbyProfile();
    // }
    // });

    this.sessionservice.observandoLogout();
    this.analyticsService.startTrackerWithId('G-B9WGFTXBKM');
  }
  askTrackingPermission() {
    if (this.platform.is('cordova') && this.platform.is('ios')) {

      if (window.cordova) {
        console.log('trying to request permission ');
        window.cordova.exec(this.processResponse, this.processResponse, 'idfa', "requestPermission", []);
      }
    }
  }
  processResponse(res: any) {
    //console.log('response of permission: ' + JSON.stringify(res));
  }

  // readTrackingPermission() {

  //   if (this.platform.is('cordova') && this.platform.is('ios')) {

  //     if (window.cordova) {
  //       window.cordova.exec(this.processResponse, this.processResponse, 'idfa', "getInfo", []);
  //     }
  //   }
  // }

  //Consulta los menus asignados al usuario
  async GetMenusbyProfile(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.storage.get('client').then((client) => {
        if (client) {
          this.clientStorage = client;
          if (this.clientStorage.RClient.ClientID != this.loggedUser) {
            this.menusRefreshed = false;
            this.locationsRefreshed = false;
            this.menus = null;
          }
          this.loggedUser = this.clientStorage.RClient.ClientID;
          const path = this.WSIdentityUrl + 'api/Menus/GetMenusbyProfile';
          //this.GetLocationsByEmployeeID();

          if (!this.menusRefreshed) {
            this.tokenService.ActualizarToken().then(
              (data) => {
                if (data) {
                  this.clientStorage = data;
                  if (this.clientStorage) {
                    if (
                      this.clientStorage.RClient.EmployeeID !== null &&
                      this.clientStorage.RClient.JobTitleID !== null
                    ) {
                      this.isEjecutive = true;
                    } else {
                      this.isEjecutive = false;
                    }
                  }
                  let parametrosmenus: AuthenticationToken = {
                    authToken: this.clientStorage.Token,
                    loginType: this.clientStorage.LoginType,
                    userName: this.clientStorage.RClient.UserName,
                  };
                  this.genericMenuService
                    .MethodPostTokenAsync(parametrosmenus, path)
                    .then(
                      (data) => {
                        this.resultMenus = data;
                        if (this.resultMenus.Result != null) {
                          this.menusRefreshed = true;
                          this.menus = data['Result'];
                          resolve(this.clientStorage);
                        }
                      },
                      (err) => {
                        reject('');
                      }
                    );
                }
              },
              (err) => {
                reject('');
              }
            );
          }
        }
      });
    });
  }

  async Logout() {
    this.menusRefreshed = false;
    this.locationsRefreshed = false;
    this.menus = null;
    //Se borran todas las variables asociadas al usuario actual
    this.sessionservice.Logout();
  }

  onMenuOpen() {
    this.GetMenusbyProfile().then(
      (data) => {
        if (this.clientStorage) {
          if (this.clientStorage.RClient.EmployeeID !== null) {
            this.GetLocationsByEmployeeID();
            this.GetCertificatesFiltered();
          }
        }
      },
      (err) => { }
    );
  }

  async closeMenu(model: any) {
    this.menuprincipal.close('main-menu');
    if (model.url === '/ofertahoteles' || model.url === '/list-recent-events') {
      this.router.onSameUrlNavigation = 'reload';
      this.router.navigate([model.url + '/' + this.LocationID]);
      // this.router.navigate(['ofertahoteles/' + this.LocationID], {queryParams: {LocationID: this.LocationID}});
    } else {
      this.router.onSameUrlNavigation = 'reload';
      this.router.navigate([model.url]);
    }
  }

  async GetLocationsByEmployeeID() {
    if (!this.locationsRefreshed) {
      const path =
        this.WSIdentityUrl +
        'api/Locations/GetLocationsByEmployeeID?EmployeeID=' +
        this.clientStorage.RClient.EmployeeID;

      this.genericLocation.MethodGetTokenAsync(path).then(
        (res) => {
          this.resultLocation = res;
          if (this.resultLocation.Result != null) {
            this.locationsRefreshed = true;
            this.location = this.resultLocation.Result;
            this.LocId = this.location[0].LocationID;
            this.LocationID = this.location[0].LocationID;
            this.LocationName = this.location[0].LocationName;
            this.storage.set('LocationEmployee', this.LocationID);
            this.storage.set('LocationName', this.LocationName);
            this.locationChanged = false;
          }
        },
        (err) => { }
      );
    }
  }

  onChangeLocation($event) {
    this.LocationID = $event.target.value;
    this.storage.set('LocationEmployee', this.LocationID);
    this.locationChanged = false;
    this.GetCertificatesFiltered();
  }

  async GetCertificatesFiltered() {
    if (!this.locationChanged) {
      this.tokenService.ActualizarToken().then(
        (data) => {
          if (data) {
            this.clientStorage = data;
            const path =
              this.WSIdentityUrl +
              'api/CertificatesInventory/GetCertificatesFiltered?IsNew=true&LastWeek=true&pageNumber=5&location=' +
              (this.LocationID != undefined ? this.LocationID : 0) +
              '&employee=' +
              this.clientStorage.RClient.EmployeeID;
            this.genericCertificate.MethodGetTokenAsync(path).then(
              (res) => {
                this.resultCertificate = res;
                if (Object.keys(this.resultCertificate.Result).length > 0) {
                  this.menusRefreshed = true;
                  this.certificate = this.resultCertificate.Result;
                  this.numotifications = Object.keys(
                    this.resultCertificate.Result
                  ).length;
                } else {
                  this.numotifications = 0;
                }
                this.locationChanged = true;
              },
              (err) => { }
            );
          }
        },
        (err) => { }
      );
    }
  }

  async seeLstRecentEvent() {
    if (this.numotifications !== 0) {
      this.menuprincipal.close('main-menu');
      this.router.onSameUrlNavigation = 'reload';
      this.router.navigate(['list-recent-events/' + this.LocationID]);
    } else {
      this.presentAlertWarning();
    }
  }

  async presentAlertWarning() {
    const alert = await this.alertController.create({
      header: 'Confirmar',
      message: 'No se encontraron certificados nuevos',
      buttons: [
        {
          text: 'OK',
          handler: () => { },
        },
      ],
    });
    await alert.present();
  }

  editClient() {
    this.menuprincipal.close('main-menu');
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate(['edit-client/'], { queryParams: { isMenu: true } });
  }
}
